module.exports = __webpack_public_path__ + "img/banner.762219b1.jpg";